/* Accesorios Pro Selector — externalized from accesorios-pro-selector.liquid (2026-05-28).
   Reads per-instance config from the root element's data-* attributes.
   Loaded with defer to keep it off the critical render path (TBT reduction). */
(function () {
  'use strict';
  function initAPS(root) {
  if (!root) return;
  var UID = root.dataset.uid;
  var SECTION_ID = root.dataset.sectionId;
  var BRAND_PH = root.dataset.brandPh || 'Select Brand';
  var MODEL_PH = root.dataset.modelPh || 'Select Model';

  /* ── Config ── */
  const cfg = {
    brandNs:    root.dataset.brandNs,
    brandKey:   root.dataset.brandKey,
    modelNs:    root.dataset.modelNs,
    modelKey:   root.dataset.modelKey,
    mStyle:     root.dataset.mobileStyle,
    mSticky:    root.dataset.mobileSticky === 'true',
    dSticky:    root.dataset.desktopSticky === 'true',
    showVF:     root.dataset.showVf === 'true',
    showQB:     root.dataset.showQb === 'true',
    showHover:  root.dataset.showHover === 'true',
    hPrefix:    root.dataset.hp,
    hDefault:   root.dataset.hd,
    logoUrl:    root.dataset.logoUrl || '',
    logoTop:    parseInt(root.dataset.logoTop) || 8,
    logoLeft:   parseInt(root.dataset.logoLeft) || 8,
    logoSize:   parseInt(root.dataset.logoSize) || 48,
    labelPlacement: root.dataset.labelPlacement || 'above',
    waNumber:       root.dataset.waNumber || '',
    waMsg:          root.dataset.waMsg || 'Hi, I am looking for cases for [MODEL]. Do you have it in stock?',
    aliasRules:     root.dataset.aliasRules || '',
    ga4Enabled:     root.dataset.ga4Enabled === 'true',
    ga4Event:       root.dataset.ga4Event || 'model_viewed',
    placement:      root.dataset.placement || 'product_section',
    scrollTargetId: root.dataset.scrollTargetId || '',
  };

  /* ── Search normalization ── */
  function normalizeStr(s) {
    return s.toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  const aliasMap = {};
  cfg.aliasRules.split('\n').forEach(line => {
    const idx = line.indexOf('=');
    if (idx < 1) return;
    const abbr = normalizeStr(line.slice(0, idx).trim());
    const full  = normalizeStr(line.slice(idx + 1).trim());
    if (abbr && full) aliasMap[abbr] = full;
  });

  /* Built-in abbreviation expansions — covers all major Indian market brands */
  function expandQuery(raw) {
    const out = new Set([raw]);
    const add = s => { if (s) out.add(s); };

    /* ── Step 1: Common brand-name typo corrections ────────────── */
    const q = raw
      .replace(/^sumsung|^samsong|^samsang|^samsyng|^samung|^samsumg|^samaung|^sumsang|^samsng/, 'samsung')
      .replace(/^opop/, 'oppo')
      .replace(/^realmi/, 'realme')
      .replace(/^motrola|^motorolla|^motorla/, 'motorola')
      .replace(/^iphome/, 'iphone')
      .replace(/^iphon(?=\d)/, 'iphone')
      .replace(/^galxy/, 'galaxy')
      .replace(/^xiomi|^xiami|^xaomi|^xiomie/, 'xiaomi')
      .replace(/ultar$|ultara$|ulra$/, 'ultra')
      .replace(/pluse$/, 'plus')
      .replace(/(\d)f$/, '$1fe');
    if (q !== raw) out.add(q);

    /* ── Step 2: Apple iPhone ──────────────────────────────────── */
    const ip = q.replace(/^ip(?=\d|x|s|r)/, 'iphone').replace(/^iph(?=\d|x|s|r)/, 'iphone');
    add(ip);
    const bases = ip !== q ? [q, ip] : [q];
    bases.forEach(s => {
      add(s.replace(/(\d)pm$/, '$1promax'));
      add(s.replace(/pm$/, 'promax'));
      add(s.replace(/(\d)p$/, '$1pro'));
      add(s.replace(/(\d)pl$/, '$1plus'));
      add(s.replace(/(\d)u$/, '$1ultra'));
    });

    /* ── Step 3: Samsung Galaxy ────────────────────────────────── */
    /* "sam" prefix: samm31 → samsungm31 / galaxym31 */
    add(q.replace(/^sam([smafj]\d.*)$/, 'samsung$1'));
    add(q.replace(/^sam([smafj]\d.*)$/, 'galaxy$1'));
    /* "galaxy" prefix typed by customer → samsung equivalent */
    add(q.replace(/^galaxy([smafj]\d+)/, 'samsung$1'));
    add(q.replace(/^galaxy(note\d+)/, 'samsung$1'));
    add(q.replace(/^galaxy(z?fold\d+)/, 'samsung$1'));
    add(q.replace(/^galaxy(z?flip\d+)/, 'samsung$1'));
    add(q.replace(/^galaxy(tab[sa]\d+)/, 'samsung$1'));
    /* Series shorthands s23, a54, m31 → both galaxy and samsung forms */
    ['s','a','m','f','j'].forEach(p => {
      add(q.replace(new RegExp(`^${p}(\\d{1,2})$`), `galaxy${p}$1`));
      add(q.replace(new RegExp(`^${p}(\\d{1,2})$`), `samsung${p}$1`));
      add(q.replace(new RegExp(`^${p}(\\d{1,2})(fe|ultra|plus|lite|5g|e)$`), `galaxy${p}$1$2`));
      add(q.replace(new RegExp(`^${p}(\\d{1,2})(fe|ultra|plus|lite|5g|e)$`), `samsung${p}$1$2`));
    });
    add(q.replace(/^(z?fold)(\d+)$/, 'galaxy$1$2'));
    add(q.replace(/^(z?flip)(\d+)$/, 'galaxy$1$2'));
    add(q.replace(/^(z?fold)(\d+)$/, 'samsung$1$2'));
    add(q.replace(/^(z?flip)(\d+)$/, 'samsung$1$2'));
    add(q.replace(/^note(\d{1,2})/, 'galaxynote$1'));
    add(q.replace(/^note(\d{1,2})/, 'samsungnote$1'));
    add(q.replace(/^tab([sa]\d)/, 'galaxytab$1'));
    add(q.replace(/^tab([sa]\d)/, 'samsungtab$1'));
    add(q.replace(/fe$/, 'fanedition'));
    /* Strip brand prefix from full compound queries e.g. "samsung galaxy a05s" */
    const noSam    = q.replace(/^samsung/, '');
    const noSamGal = q.replace(/^samsung(?:galaxy)?/, '');
    const noGal    = q.replace(/^galaxy/, '');
    if (noSam    && noSam    !== q) out.add(noSam);
    if (noSamGal && noSamGal !== q) out.add(noSamGal);
    if (noGal    && noGal    !== q) out.add(noGal);

    /* ── Step 4: OnePlus ───────────────────────────────────────── */
    add(q.replace(/^op(\d)/, 'oneplus$1'));
    add(q.replace(/^1\+?(\d)/, 'oneplus$1'));
    add(q.replace(/^onep(\d)/, 'oneplus$1'));

    /* ── Step 5: Xiaomi / Redmi / POCO ────────────────────────── */
    /* Strip Xiaomi sub-brand prefix so "redmi 12c" finds model "12C" etc. */
    const noXm  = q.replace(/^xiaomi(?:redmi)?/, '');
    if (noXm  && noXm  !== q && noXm.length  >= 2) out.add(noXm);
    const noRdm = q.replace(/^redmi(?:note)?/, '');
    if (noRdm && noRdm !== q && noRdm.length >= 2) out.add(noRdm);
    const noMi  = q.replace(/^mi(?=\d)/, '');
    if (noMi  && noMi  !== q && noMi.length  >= 2) out.add(noMi);
    add(q.replace(/^rn(\d+)/, 'redminote$1'));
    add(q.replace(/^rm(\d+)/, 'redmi$1'));
    add(q.replace(/^poco([cfxmt])(\d)/, 'poco$1$2'));
    add(q.replace(/^mi(\d+\w*)$/, 'xiaomimi$1'));   /* mi11t, mi12pro → xiaomimi... */
    add(q.replace(/^mi(\d+\w*)$/, 'mi$1'));

    /* ── Step 6: Vivo ──────────────────────────────────────────── */
    add(q.replace(/^v(\d{2})(pro|plus|e|5g)?$/, 'vivov$1$2'));
    add(q.replace(/^y(\d{2,3})(pro|plus|e|5g)?$/, 'vivoy$1$2'));
    add(q.replace(/^x(\d{2,3})(pro|plus)?$/, 'vivox$1$2'));
    add(q.replace(/^t(\d)pro?$/, 'vivot$1pro'));

    /* ── Step 7: OPPO (Reno is part of OPPO) ──────────────────── */
    add(q.replace(/^reno(\d+)/, 'opporeno$1'));            /* reno10, reno12 → opporeno10/12 */
    add(q.replace(/^find([xn]\d+)/, 'oppofind$1'));        /* findx7 → oppofindx7 */
    add(q.replace(/^a(\d{2})(pro|s|x|5g)?$/, 'oppoa$1$2'));
    add(q.replace(/^k(\d{2})$/, 'oppok$1'));

    /* ── Step 8: Realme ────────────────────────────────────────── */
    add(q.replace(/^c(\d{2,3})/, 'realmec$1'));
    add(q.replace(/^gt(\d+)/, 'realmegt$1'));
    add(q.replace(/^narzo(\d{2})/, 'realmenarzo$1'));
    add(q.replace(/^p(\d)5g$/, 'realmep$15g'));

    /* ── Step 9: Motorola ──────────────────────────────────────── */
    add(q.replace(/^g(\d{2,3})/, 'motorolag$1'));
    add(q.replace(/^motog(\d+)/, 'motorolag$1'));
    add(q.replace(/^moto([ge])(\d+)/, 'motorola$1$2'));
    add(q.replace(/^moto(?!rola)/, 'motorola'));            /* moto razr40, moto g84 → motorola... */
    add(q.replace(/^edge(\d{2,3})/, 'motorolaedge$1'));
    add(q.replace(/^razr(\d)$/, 'motorolarazr$1'));

    /* ── Step 10: Nothing Phone ────────────────────────────────── */
    add(q.replace(/^np(\d)$/, 'nothingphone$1'));
    add(q.replace(/^nothing(p?)(\d)/, 'nothingphone$2'));  /* nothing2, nothingp2 → nothingphone2 */

    /* ── Step 11: iQOO ─────────────────────────────────────────── */
    add(q.replace(/^iqoo(\d)/, 'iqoo$1'));
    add(q.replace(/^neo(\d)/, 'iqooneo$1'));
    add(q.replace(/^z(\d+)(pro|neo|e)?$/, 'iqooz$1$2'));

    return [...out];
  }

  /* Levenshtein edit distance (single-row DP, O(m*n)) */
  function editDist(a, b) {
    const m = a.length, n = b.length;
    const row = Array.from({length: n + 1}, (_, j) => j);
    for (let i = 1; i <= m; i++) {
      let prev = row[0]; row[0] = i;
      for (let j = 1; j <= n; j++) {
        const tmp = row[j];
        row[j] = a[i-1] === b[j-1] ? prev : 1 + Math.min(prev, row[j], row[j-1]);
        prev = tmp;
      }
    }
    return row[n];
  }

  function fuzzyMatch(query, target, brand) {
    if (!query) return true;
    const candidates = expandQuery(query);
    const bn = brand ? normalizeStr(brand) : '';
    for (const c of candidates) {
      if (target.includes(c)) return true;
      if (aliasMap[c] && target.includes(aliasMap[c])) return true;
      for (const [abbr, full] of Object.entries(aliasMap)) {
        if (c.includes(abbr) && target.includes(full)) return true;
      }
      /* Brand-prefixed model query: when a brand is selected the model list holds
         only model names ("Y31 5G"), so "vivo y31" / "samsung a36" can't match.
         Strip the selected brand token from the front and retry. Brand-agnostic. */
      if (bn && c.length > bn.length && c.startsWith(bn)) {
        const stripped = c.slice(bn.length);
        if (stripped && target.includes(stripped)) return true;
      }
    }
    /* Universal fallback: catch remaining typos via approximate substring matching.
       Skip when query contains digits — model numbers are precision-critical (m02a ≠ m02s). */
    if (query.length >= 3 && !/\d/.test(query)) {
      const maxErr = query.length <= 5 ? 1 : 2;
      const ql = query.length;
      for (let i = 0; i <= target.length - ql + maxErr; i++) {
        for (let wl = Math.max(1, ql - maxErr); wl <= ql + maxErr && i + wl <= target.length; wl++) {
          if (editDist(query, target.slice(i, i + wl)) <= maxErr) return true;
        }
      }
    }
    return false;
  }

  /* ── Data ── */
  let bmData = [];          // [{brand, models[]}]
  let labelCfg = {};
  let labelRules = {};      // { modelName: {text, style} }
  let state = { brand: null, models: new Set() };
  let sheetCtx = null;      // 'brand' | 'model'
  let fetchTimer = null;

  /* ── DOM ── */
  const brandBtn   = document.getElementById('aps-brand-btn-' + UID);
  const modelBtn   = document.getElementById('aps-model-btn-' + UID);
  const brandPanel = document.getElementById('aps-brand-panel-' + UID);
  const modelPanel = document.getElementById('aps-model-panel-' + UID);
  const brandOpts  = brandPanel.querySelector('[data-aps-opts="brand"]');
  const modelOpts  = document.getElementById('aps-model-opts-' + UID);
  const brandSearch= brandPanel.querySelector('[data-aps-search="brand"]');
  const modelSearch= modelPanel.querySelector('[data-aps-search="model"]');
  const brandNores = brandPanel.querySelector('[data-aps-nores="brand"]');
  const modelNores = modelPanel.querySelector('[data-aps-nores="model"]');
  const results    = document.getElementById('aps-results-' + UID);
  const grid       = document.getElementById('aps-grid-' + UID);
  const skeleton   = document.getElementById('aps-skeleton-' + UID);
  const labelsBar  = document.getElementById('aps-labels-' + UID);
  const activeRow  = document.getElementById('aps-active-' + UID);
  const seoH       = document.getElementById('aps-seo-h-' + UID);
  const filterCard = document.getElementById('aps-filter-card-' + UID);
  const stickyBar  = document.getElementById('aps-sticky-' + UID);
  const sSpBrand   = document.getElementById('aps-sp-brand-' + UID);
  const sSpModel   = document.getElementById('aps-sp-model-' + UID);
  const backdrop   = document.getElementById('aps-bd-' + UID);
  const sheetTitle = document.getElementById('aps-sheet-title-' + UID);
  const sheetOpts  = document.getElementById('aps-sheet-opts-' + UID);
  const sheetSearch= document.getElementById('aps-sheet-search-' + UID);
  const sheetNores = document.getElementById('aps-sheet-nores-' + UID);
  const sheetFoot  = document.getElementById('aps-sheet-footer-' + UID);
  const sheetClear = document.getElementById('aps-sheet-clear-' + UID);
  const sheetClose = document.getElementById('aps-sheet-close-' + UID);
  const clearModels= modelPanel.querySelector('[data-aps-clear-models]');
  const dealCenter = document.getElementById('aps-deals-' + UID);

  /* ── Init ── */
  function init() {
    try { bmData = JSON.parse(document.getElementById('aps-bm-' + UID).textContent); } catch(e) { console.error('[APS] brand-model data parse failed — selector will be empty', e); }
    try {
      labelCfg = JSON.parse(document.getElementById('aps-lcfg-' + UID).textContent);
      parseLabelRules(labelCfg.rules || '');
    } catch(e) {}

    populateBrands();
    bindEvents();
    if (cfg.mSticky || cfg.dSticky) setupSticky();
    positionLabels();

    const p = new URLSearchParams(location.search);
    const ub = p.get('brand'), um = p.get('model');
    if (ub) {
      const entry = bmData.find(d => d.brand === ub);
      if (entry) {
        requestIdleCallback
          ? requestIdleCallback(() => restoreURL(ub, um ? um.split(',') : []))
          : restoreURL(ub, um ? um.split(',') : []);
      }
    }
    /* ACC 2026-06-02: eager prefetchAllModels() DISABLED — it fetched every brand ×
       up to 20 pages in parallel on load → HTTP 429 flood + ERR_INSUFFICIENT_RESOURCES
       on home + collection. Models now load on-tap via selectBrand→populateModels→
       fetchModelsForBrand (one brand at a time). Re-enable only if rate-limit-safe. */
  }

  function parseLabelRules(raw) {
    raw.split('\n').forEach(line => {
      const parts = line.split(':');
      if (parts.length < 2) return;
      const model = parts[0].trim();
      const text  = parts[1].trim();
      const style = parseInt(parts[2]) || 1;
      if (model) labelRules[model] = { text, style: Math.min(Math.max(style, 1), 3) };
    });
  }

  /* ── Brand population ── */
  function populateBrands() {
    const sorted = [...bmData].sort((a, b) => a.brand.localeCompare(b.brand));
    brandOpts.innerHTML = sorted.map(d =>
      `<li class="aps-opt is-single" role="option" aria-selected="false" data-val="${ea(d.brand)}">${eh(d.brand)}</li>`
    ).join('');
    if (!bmData.length) brandNores.style.display = 'block';
  }

  /* ── Model population ── */
  async function populateModels(brand) {
    const entry = bmData.find(d => d.brand === brand);
    if (entry && entry._cachedModels) { renderModelOpts(entry._cachedModels); return; }
    const manual = entry ? entry.models.filter(m => m && m.trim()) : [];
    if (manual.length) { renderModelOpts(manual); return; }
    await fetchModelsForBrand(brand);
  }

  function renderModelOpts(models) {
    const sorted = [...models].sort((a, b) => a.localeCompare(b));
    modelOpts.innerHTML = sorted.map(m => {
      const rule = labelRules[m];
      let lbl = '';
      if (rule) {
        const animKey = labelCfg[`s${rule.style}anim`] || 'fadein';
        let extraStyle = 'margin-left:auto;font-size:10px;flex-shrink:0;line-height:1.4;';
        if (animKey === 'shine') {
          const bg = labelCfg[`s${rule.style}shine_bg`] || '#1a1a2e';
          extraStyle += `background:linear-gradient(90deg,${bg} 0%,#ffffff66 50%,${bg} 100%);background-size:200% auto;`;
        }
        lbl = `<span class="aps-lbl-${rule.style} aps-anim-${animKey}" style="${extraStyle}">${eh(rule.text)}</span>`;
      }
      return `<li class="aps-opt" role="option" aria-checked="${state.models.has(m)}" data-val="${ea(m)}">
        <span class="aps-cb" aria-hidden="true"></span>
        ${eh(m)}${lbl}
      </li>`;
    }).join('');
    modelNores.style.display = models.length ? 'none' : 'block';
    modelBtn.disabled = models.length === 0;
  }

  async function fetchBrandPage(brand, page) {
    const params = new URLSearchParams();
    params.set(`filter.p.m.${cfg.brandNs}.${cfg.brandKey}`, brand);
    params.set('sections', SECTION_ID);
    params.set('page', page);
    try {
      const resp = await fetch(`/collections/all?${params.toString()}`);
      if (!resp.ok) return null;
      const json = await resp.json();
      const rendered = json[SECTION_ID];
      if (!rendered) return null;
      const doc = new DOMParser().parseFromString(rendered, 'text/html');
      const el = doc.getElementById('aps-mf-data-' + UID);
      if (!el) return null;
      const data = JSON.parse(el.textContent || '{"models":[]}');
      return (data.models || []).filter(Boolean);
    } catch(e) { return null; }
  }

  async function fetchAllModelsForBrand(brand, onPage) {
    const allModels = new Set();
    outer: for (let start = 1; start <= 20; start += 5) {
      const pages = [start, start+1, start+2, start+3, start+4].filter(p => p <= 20);
      const results = await Promise.all(pages.map(p => fetchBrandPage(brand, p)));
      let batchEmpty = false;
      for (const models of results) {
        if (!models || models.length === 0) { batchEmpty = true; break; }
        models.forEach(m => allModels.add(m));
      }
      if (allModels.size > 0 && onPage) onPage([...allModels]);
      if (batchEmpty) break;
    }
    return [...allModels];
  }

  async function fetchModelsForBrand(brand) {
    modelBtn.disabled = true;
    modelOpts.innerHTML = '<li style="padding:16px;text-align:center;opacity:.45;list-style:none">Loading models…</li>';
    const models = await fetchAllModelsForBrand(brand, (partial) => {
      if (state.brand !== brand) return;
      renderModelOpts(partial);
    });
    const entry = bmData.find(d => d.brand === brand);
    /* ACC 2026-06-02: only cache a non-empty result. Caching an empty [] from a
       failed/throttled fetch would permanently lock the brand as "no models" for
       the session (no retry). Empty stays uncached → next tap re-fetches. */
    if (entry && models.length > 0) entry._cachedModels = models;
    if (state.brand === brand) renderModelOpts(models);
  }

  function prefetchAllModels() {
    bmData.forEach((entry, i) => {
      if (entry._cachedModels) return;
      if ((entry.models || []).filter(m => m && m.trim()).length) return;
      setTimeout(async () => {
        const models = await fetchAllModelsForBrand(entry.brand);
        if (models.length > 0) entry._cachedModels = models;
      }, i * 300);
    });
  }

  /* ── Open / close dropdowns ── */
  function open(type) {
    const isMobile = window.matchMedia('(max-width:749px)').matches;
    if (isMobile && cfg.mStyle === 'bottom-sheet') { openSheet(type); return; }
    closeAll();
    const btn   = type === 'brand' ? brandBtn : modelBtn;
    const panel = type === 'brand' ? brandPanel : modelPanel;
    panel.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    btn.classList.add('is-active');
    const si = panel.querySelector('.aps-panel-search');
    if (si) { si.value = ''; applySearch(si, panel, type === 'model'); si.focus(); }
  }

  function closeAll() {
    [brandPanel, modelPanel].forEach(p => p.classList.remove('is-open'));
    [brandBtn, modelBtn].forEach(b => { b.setAttribute('aria-expanded','false'); b.classList.remove('is-active'); });
  }

  /* ── Bottom sheet ── */
  function openSheet(type) {
    sheetCtx = type;
    const isBrand = type === 'brand';
    sheetTitle.textContent = isBrand
      ? (document.querySelector(`label[for="aps-brand-btn-${UID}"]`)?.textContent?.trim() || 'Brand')
      : (document.querySelector(`label[for="aps-model-btn-${UID}"]`)?.textContent?.trim() || 'Model');
    const srcList = isBrand ? brandOpts : modelOpts;
    sheetOpts.innerHTML = srcList.innerHTML;
    // Sync checked states — aria-checked drives the custom .aps-cb visual
    if (!isBrand) {
      sheetOpts.querySelectorAll('.aps-opt').forEach(li => {
        li.setAttribute('aria-checked', state.models.has(li.dataset.val));
      });
    }
    sheetSearch.value = '';
    sheetSearch.placeholder = isBrand ? 'Search brands…' : 'Search models…';
    sheetNores.style.display = 'none';
    sheetOpts.querySelectorAll('.aps-opt').forEach(li => li.style.display = '');
    sheetFoot.style.display = isBrand ? 'none' : '';
    backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    sheetSearch.focus();
  }

  function closeSheet() {
    backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
    sheetCtx = null;
  }

  /* ── Selection ── */
  async function selectBrand(brand) {
    state.brand = brand;
    state.models = new Set();
    closeAll(); closeSheet();
    updateBrandDisplay(brand);
    syncBrandOpts(brand);
    updateModelDisplay();
    updateStickyBar();
    results.classList.remove('is-visible');
    grid.innerHTML = '';
    activeRow.innerHTML = '';
    labelsBar.innerHTML = '';
    seoH.textContent = '';
    pushHistory();
    await populateModels(brand);
  }

  function toggleModel(model) {
    const adding = !state.models.has(model);
    if (state.models.has(model)) state.models.delete(model);
    else state.models.add(model);
    if (adding && cfg.ga4Enabled) {
      try {
        const payload = { phone_model_name: model, brand: state.brand };
        if (window.gtag) gtag('event', cfg.ga4Event, payload);
        if (window.dataLayer) dataLayer.push({ event: cfg.ga4Event, ...payload });
      } catch(_) {}
    }
    updateModelDisplay();
    syncModelOpts();
    updateStickyBar();
    scheduleFetch();
    pushHistory();
  }

  function clearModelsState() {
    state.models = new Set();
    updateModelDisplay();
    syncModelOpts();
    sheetOpts.querySelectorAll('.aps-opt').forEach(li => {
      li.setAttribute('aria-checked', 'false');
    });
    updateStickyBar();
    results.classList.remove('is-visible');
    if (dealCenter) dealCenter.classList.remove('is-visible');
    grid.innerHTML = '';
    activeRow.innerHTML = '';
    labelsBar.innerHTML = '';
    seoH.textContent = '';
    pushHistory();
  }

  function clearBrandState() {
    state.brand = null;
    state.models = new Set();
    closeAll(); closeSheet();
    updateBrandDisplay(null);
    syncBrandOpts(null);
    updateModelDisplay();
    updateStickyBar();
    modelOpts.innerHTML = '';
    modelBtn.disabled = true;
    results.classList.remove('is-visible');
    if (dealCenter) dealCenter.classList.remove('is-visible');
    grid.innerHTML = '';
    activeRow.innerHTML = '';
    labelsBar.innerHTML = '';
    seoH.textContent = '';
    pushHistory();
  }

  /* ── Sync opt states ── */
  function syncBrandOpts(brand) {
    brandOpts.querySelectorAll('.aps-opt').forEach(li => {
      const sel = li.dataset.val === brand;
      li.setAttribute('aria-selected', sel);
    });
  }

  function syncModelOpts() {
    [modelOpts, sheetOpts].forEach(list => {
      list.querySelectorAll('.aps-opt').forEach(li => {
        li.setAttribute('aria-checked', state.models.has(li.dataset.val));
      });
    });
  }

  /* ── Display updates ── */
  function updateBrandDisplay(brand) {
    const ph = brandBtn.querySelector('[data-ph="brand"]');
    const existing = [...brandBtn.querySelectorAll('.aps-chip')];
    existing.forEach(c => c.remove());
    if (ph) ph.style.display = brand ? 'none' : '';
    if (brand) {
      const chip = document.createElement('span');
      chip.className = 'aps-chip';
      chip.innerHTML = `${eh(brand)} <button class="aps-chip-x" data-rm-brand aria-label="Clear brand">×</button>`;
      brandBtn.insertBefore(chip, brandBtn.querySelector('.aps-trigger-chevron'));
    }
  }

  function updateModelDisplay() {
    const ph = modelBtn.querySelector('[data-ph="model"]');
    [...modelBtn.querySelectorAll('.aps-chip')].forEach(c => c.remove());
    const models = [...state.models];
    if (!models.length) {
      if (ph) ph.style.display = '';
      return;
    }
    if (ph) ph.style.display = 'none';
    const show = models.slice(0, 2);
    const more = models.length - show.length;
    show.forEach(m => {
      const chip = document.createElement('span');
      chip.className = 'aps-chip';
      chip.innerHTML = `${eh(m)} <button class="aps-chip-x" data-rm="${ea(m)}" aria-label="Remove ${ea(m)}">×</button>`;
      modelBtn.insertBefore(chip, modelBtn.querySelector('.aps-trigger-chevron'));
    });
    if (more > 0) {
      const chip = document.createElement('span');
      chip.className = 'aps-chip';
      chip.textContent = `+${more} more`;
      modelBtn.insertBefore(chip, modelBtn.querySelector('.aps-trigger-chevron'));
    }
  }

  function updateStickyBar() {
    if (!stickyBar) return;
    if (sSpBrand) {
      const t = sSpBrand.querySelector('span');
      if (t) t.textContent = state.brand || BRAND_PH;
      sSpBrand.classList.toggle('has-value', !!state.brand);
    }
    if (sSpModel) {
      const cnt = state.models.size;
      const t = sSpModel.querySelector('span');
      if (t) t.textContent = cnt ? `${cnt} model${cnt > 1 ? 's' : ''} selected` : MODEL_PH;
      sSpModel.disabled = !state.brand;
      sSpModel.classList.toggle('has-value', cnt > 0);
    }
  }

  /* ── Active chips row ── */
  function renderActiveRow() {
    if (!state.brand && !state.models.size) { activeRow.innerHTML = ''; return; }
    let html = '';
    if (state.brand) {
      html += `<span class="aps-active-chip"><strong>${eh(state.brand)}</strong></span>`;
    }
    state.models.forEach(m => {
      html += `<span class="aps-active-chip">${eh(m)}<button data-rm-model="${ea(m)}" aria-label="Remove ${ea(m)}">×</button></span>`;
    });
    if (state.models.size > 1) html += `<button class="aps-clear-all" data-clear-all>Clear all</button>`;
    activeRow.innerHTML = html;
  }

  /* ── Label pills ── */
  function renderLabels() {
    labelsBar.innerHTML = '';
    state.models.forEach(model => {
      const rule = labelRules[model];
      if (!rule) return;
      const animKey = labelCfg[`s${rule.style}anim`] || 'fadein';
      const span = document.createElement('span');
      span.className = `aps-lbl-${rule.style}`;
      if (animKey === 'shine') {
        const bg = labelCfg[`s${rule.style}shine_bg`] || '#1a1a2e';
        span.style.background = `linear-gradient(90deg,${bg} 0%,#ffffff66 50%,${bg} 100%)`;
        span.style.backgroundSize = '200% auto';
      }
      span.textContent = rule.text;
      labelsBar.appendChild(span);
      requestAnimationFrame(() => span.classList.add(`aps-anim-${animKey}`));
    });
  }

  /* ── SEO heading ── */
  function updateSEO() {
    let text = '';
    if (state.brand && state.models.size) {
      const mList = [...state.models].join(' / ');
      text = `${cfg.hPrefix} ${mList}`;
    } else if (state.brand) {
      text = `${cfg.hPrefix} ${state.brand}`;
    }
    seoH.textContent = text;
    if (text) {
      const base = document.title.split(' — ').slice(-1)[0];
      document.title = `${text} — ${base}`;
    }
  }

  /* ── AJAX fetch ── */
  function scheduleFetch() {
    clearTimeout(fetchTimer);
    if (!state.models.size) {
      results.classList.remove('is-visible');
      if (dealCenter) dealCenter.classList.remove('is-visible');
      grid.innerHTML = '';
      renderActiveRow();
      renderLabels();
      updateSEO();
      return;
    }
    fetchTimer = setTimeout(fetchProducts, 280);
  }

  async function fetchProducts() {
    results.classList.add('is-visible');
    if (dealCenter) dealCenter.classList.add('is-visible');
    skeleton.classList.add('is-on');
    grid.style.visibility = 'hidden';
    renderActiveRow();
    renderLabels();
    updateSEO();

    const params = new URLSearchParams();
    state.models.forEach(m => params.append(`filter.p.m.${cfg.modelNs}.${cfg.modelKey}`, m));
    params.set('sections', SECTION_ID);

    try {
      const resp = await fetch(`/collections/all?${params.toString()}`);
      if (!resp.ok) throw new Error(resp.status);
      const json = await resp.json();
      const rendered = json[SECTION_ID];
      if (rendered) {
        const doc = new DOMParser().parseFromString(rendered, 'text/html');
        const newGrid = doc.getElementById('aps-grid-' + UID);
        grid.innerHTML = newGrid ? newGrid.innerHTML : '<p class="aps-empty-state">No cases found.</p>';
      } else {
        grid.innerHTML = '<p class="aps-empty-state">No cases found.</p>';
      }
    } catch (e) {
      grid.innerHTML = '<p class="aps-empty-state">Could not load products. Please try again.</p>';
    } finally {
      skeleton.classList.remove('is-on');
      grid.style.visibility = '';
      injectLogos();
      injectVerifiedFit();
      if (state.models.size > 0) {
        const scrollEl = cfg.scrollTargetId
          ? (cfg.scrollTargetId.startsWith('.') || cfg.scrollTargetId.startsWith('#')
              ? document.querySelector(cfg.scrollTargetId)
              : document.getElementById(cfg.scrollTargetId))
          : grid;
        if (scrollEl) setTimeout(() => scrollEl.scrollIntoView({ behavior: 'smooth', block: 'start' }), 80);
      }
    }
  }

  /* ── History ── */
  function pushHistory() {
    const p = new URLSearchParams(location.search);
    if (state.brand) p.set('brand', state.brand); else p.delete('brand');
    if (state.models.size) p.set('model', [...state.models].join(',')); else p.delete('model');
    const url = location.pathname + (p.toString() ? '?' + p : '') + location.hash;
    history.pushState({ brand: state.brand, models: [...state.models] }, '', url);
  }

  async function restoreURL(brand, models) {
    await selectBrand(brand);
    if (models.length) {
      models.forEach(m => state.models.add(m));
      updateModelDisplay();
      syncModelOpts();
      updateStickyBar();
      scheduleFetch();
    }
  }

  window.addEventListener('popstate', e => {
    const s = e.state || {};
    state.brand = s.brand || null;
    state.models = new Set(s.models || []);
    updateBrandDisplay(state.brand);
    syncBrandOpts(state.brand);
    if (state.brand) populateModels(state.brand);
    updateModelDisplay();
    updateStickyBar();
    if (state.models.size) scheduleFetch();
    else { results.classList.remove('is-visible'); grid.innerHTML = ''; }
  });

  /* ── Fixed bar — appears when filter card scrolls out of view ── */
  function setupSticky() {
    if (!stickyBar || !filterCard) return;
    const obs = new IntersectionObserver(([entry]) => {
      // Only show sticky bar AFTER user has scrolled past the filter card (card above viewport).
      // Without this guard, on pages where the card starts below the fold (e.g. homepage hero above it),
      // the bar would appear at page load because the card is "not yet intersecting" from below.
      const scrolledPast = entry.boundingClientRect.top < 0;
      const show = !entry.isIntersecting && scrolledPast;
      stickyBar.classList.toggle('is-visible', show);
      stickyBar.setAttribute('aria-hidden', !show);
    }, { threshold: 0, rootMargin: '-10px 0px 0px 0px' });
    obs.observe(filterCard);
  }

  /* ── Card logo injection — first image only ── */
  function injectLogos() {
    if (!cfg.logoUrl) return;
    grid.querySelectorAll('[data-aps-card-model]').forEach(cardWrap => {
      if (cardWrap.querySelector('.aps-card-logo')) return;
      // Find the primary image container — the first suitable positionable wrapper
      const imgWrap = cardWrap.querySelector(
        '.product-card__figure, .product-card__media, .product-card__image-wrapper, .card__media, .card__figure, figure.media, figure'
      );
      if (!imgWrap) return;
      if (getComputedStyle(imgWrap).position === 'static') imgWrap.style.position = 'relative';
      const logo = document.createElement('span');
      logo.className = 'aps-card-logo';
      logo.innerHTML = `<img src="${ea(cfg.logoUrl)}" alt="" width="${cfg.logoSize}" loading="lazy">`;
      imgWrap.appendChild(logo);
    });
  }

  /* ── Verified Fit badge injection ── */
  function injectVerifiedFit() {
    if (!cfg.showVF || !state.models.size) return;
    grid.querySelectorAll('[data-aps-card-model]').forEach(wrap => {
      const model = wrap.dataset.apsCardModel;
      if (!model || !state.models.has(model)) return;
      const imgWrap = wrap.querySelector(
        '.product-card__image-wrapper, .product-card__media, .card__media, figure, [class*="image-wrap"]'
      );
      if (!imgWrap || imgWrap.querySelector('.aps-fit-badge')) return;
      if (getComputedStyle(imgWrap).position === 'static') imgWrap.style.position = 'relative';
      const badge = document.createElement('span');
      badge.className = 'aps-fit-badge';
      badge.textContent = 'Verified Fit';
      imgWrap.appendChild(badge);
    });
  }

  /* ── Label bar placement ── */
  function positionLabels() {
    if (!labelsBar || cfg.labelPlacement !== 'below') return;
    const gridContainer = results.querySelector('#product-grid-container');
    if (gridContainer) gridContainer.insertAdjacentElement('afterend', labelsBar);
  }

  /* ── Search filter ── */
  function applySearch(input, container, isModelCtx) {
    const raw = input.value;
    const q   = normalizeStr(raw);
    const list = container.querySelector('.aps-opts, .aps-sheet-opts');
    if (!list) return;
    let vis = 0;
    list.querySelectorAll('.aps-opt').forEach(li => {
      const match = fuzzyMatch(q, normalizeStr(li.dataset.val), isModelCtx ? state.brand : null);
      li.style.display = match ? '' : 'none';
      if (match) vis++;
    });
    /* Standard no-res (brand panel) */
    const nores = container.querySelector('.aps-no-res');
    if (nores && !container.querySelector('.aps-no-res-wrap')) {
      nores.style.display = vis ? 'none' : 'block';
    }
    /* WA-enabled no-res (model panel) */
    const wrap = container.querySelector('.aps-no-res-wrap');
    if (wrap) {
      wrap.style.display = vis ? 'none' : 'block';
      const waBtn = wrap.querySelector('.aps-wa-btn');
      if (waBtn && isModelCtx && raw.trim().length > 0 && !vis) {
        const msg = cfg.waMsg.replace('[MODEL]', raw.trim());
        waBtn.href = 'https://wa.me/' + cfg.waNumber + '?text=' + encodeURIComponent(msg);
        waBtn.style.display = 'flex';
      } else if (waBtn) {
        waBtn.style.display = 'none';
      }
    }
  }

  /* ── Events ── */
  function bindEvents() {
    /* Trigger buttons */
    [brandBtn, modelBtn].forEach(btn => {
      btn.addEventListener('click', e => {
        if (btn.disabled) return;
        e.stopPropagation();
        const type = btn.dataset.apsTrigger;
        const isOpen = (type === 'brand' ? brandPanel : modelPanel).classList.contains('is-open');
        closeAll();
        if (!isOpen) open(type);
      });
    });

    /* Brand chip × click */
    brandBtn.addEventListener('click', e => {
      const rm = e.target.closest('[data-rm-brand]');
      if (rm) { e.stopPropagation(); clearBrandState(); }
    });

    /* Brand clear btn in panel footer */
    const clearBrandBtn = brandPanel.querySelector('[data-aps-clear-brand]');
    if (clearBrandBtn) clearBrandBtn.addEventListener('click', clearBrandState);

    /* Brand option click */
    brandOpts.addEventListener('click', e => {
      const li = e.target.closest('.aps-opt');
      if (li) selectBrand(li.dataset.val);
    });

    /* Model option click — close panel after selection */
    modelOpts.addEventListener('click', e => {
      const li = e.target.closest('.aps-opt');
      if (!li) return;
      e.preventDefault();
      toggleModel(li.dataset.val);
      setTimeout(closeAll, 160);
    });

    /* Model chip remove (inside trigger) */
    modelBtn.addEventListener('click', e => {
      const rm = e.target.closest('[data-rm]');
      if (rm) { e.stopPropagation(); state.models.delete(rm.dataset.rm); updateModelDisplay(); syncModelOpts(); updateStickyBar(); scheduleFetch(); pushHistory(); }
    });

    /* Clear models */
    if (clearModels) clearModels.addEventListener('click', clearModelsState);

    /* Active row events */
    activeRow.addEventListener('click', e => {
      const rm = e.target.closest('[data-rm-model]');
      if (rm) { state.models.delete(rm.dataset.rmModel); updateModelDisplay(); syncModelOpts(); updateStickyBar(); scheduleFetch(); pushHistory(); }
      if (e.target.closest('[data-clear-all]')) clearModelsState();
    });

    /* Inline search */
    brandSearch.addEventListener('input', () => applySearch(brandSearch, brandPanel, false));
    modelSearch.addEventListener('input', () => applySearch(modelSearch, modelPanel, true));

    /* Sheet events */
    sheetOpts.addEventListener('click', e => {
      const li = e.target.closest('.aps-opt');
      if (!li || !sheetCtx) return;
      if (sheetCtx === 'brand') { selectBrand(li.dataset.val); closeSheet(); }
      else {
        toggleModel(li.dataset.val);
        // Sync aria-checked in sheet (drives .aps-cb visual)
        sheetOpts.querySelectorAll('.aps-opt').forEach(o => {
          o.setAttribute('aria-checked', state.models.has(o.dataset.val));
        });
        setTimeout(closeSheet, 180);
      }
    });
    sheetSearch.addEventListener('input', () => {
      const raw = sheetSearch.value;
      const q   = normalizeStr(raw);
      let vis = 0;
      sheetOpts.querySelectorAll('.aps-opt').forEach(li => {
        const match = fuzzyMatch(q, normalizeStr(li.dataset.val), sheetCtx === 'model' ? state.brand : null);
        li.style.display = match ? '' : 'none';
        if (match) vis++;
      });
      sheetNores.style.display = vis ? 'none' : 'block';
      const sheetWaBtn = sheetNores.querySelector('.aps-wa-btn');
      if (sheetWaBtn && sheetCtx === 'model' && raw.trim().length > 0 && !vis) {
        const msg = cfg.waMsg.replace('[MODEL]', raw.trim());
        sheetWaBtn.href = 'https://wa.me/' + cfg.waNumber + '?text=' + encodeURIComponent(msg);
        sheetWaBtn.style.display = 'flex';
      } else if (sheetWaBtn) {
        sheetWaBtn.style.display = 'none';
      }
    });
    sheetClose.addEventListener('click', closeSheet);
    if (sheetClear) sheetClear.addEventListener('click', () => { clearModelsState(); closeSheet(); });
    backdrop.addEventListener('click', e => { if (!e.target.closest('.aps-sheet')) closeSheet(); });

    /* Sticky bar pills */
    if (sSpBrand) sSpBrand.addEventListener('click', () => open('brand'));
    if (sSpModel) sSpModel.addEventListener('click', () => { if (!sSpModel.disabled) open('model'); });

    /* Outside click */
    document.addEventListener('click', e => { if (!root.contains(e.target) && !stickyBar?.contains(e.target)) closeAll(); });

    /* Help sheet — uses native bottom-sheet pattern */
    const helpBd    = document.getElementById('aps-help-bd-' + UID);
    const helpSheet = document.getElementById('aps-help-sheet-' + UID);
    const helpClose = document.getElementById('aps-help-close-' + UID);
    function openHelp()  { if (!helpBd) return; helpBd.classList.add('is-open'); helpSheet.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function closeHelp() { if (!helpBd) return; helpBd.classList.remove('is-open'); helpSheet.classList.remove('is-open'); document.body.style.overflow = ''; }
    root.addEventListener('click', e => { if (e.target.closest('.aps-model-help-trigger')) { e.stopPropagation(); openHelp(); } });
    if (helpClose) helpClose.addEventListener('click', closeHelp);
    if (helpBd) helpBd.addEventListener('click', e => { if (!e.target.closest('.aps-sheet')) closeHelp(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && helpBd && helpBd.classList.contains('is-open')) closeHelp(); });

    /* Escape */
    document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeAll(); closeSheet(); } });
  }

  /* ── Helpers ── */
  function eh(s) { return String(s ?? '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
  function ea(s) { return String(s ?? '').replace(/"/g,'&quot;').replace(/'/g,'&#39;'); }

  /* ── Deal Center: copy-to-clipboard, nudge, terms, carousel dots ── */
  function initDealCenter() {
    const initFn = () => {
      root.querySelectorAll('[data-aps-copy]').forEach(btn => {
        if (btn._apsInit) return;
        btn._apsInit = true;
        btn.addEventListener('click', async () => {
          const code = btn.dataset.apsCopy;
          const origHtml = btn.innerHTML;
          try {
            await navigator.clipboard.writeText(code);
          } catch(e) {
            const ta = document.createElement('textarea');
            ta.value = code; ta.style.cssText = 'position:fixed;opacity:0;top:0;left:0;';
            document.body.appendChild(ta); ta.select(); document.execCommand('copy');
            document.body.removeChild(ta);
          }
          const successText = btn.dataset.apsCopySuccess || '✓ Copied!';
          btn.innerHTML = successText;
          btn.classList.add('is-copied');
          const nudgeId = btn.dataset.apsShowNudge;
          const nudgeEl = nudgeId ? btn.parentElement.querySelector('.aps-deal-nudge[data-aps-nudge="' + nudgeId + '"]') : null;
          if (nudgeEl) nudgeEl.classList.add('is-visible');
          const gaEvt = btn.dataset.apsGaEvent;
          if (gaEvt) {
            try {
              if (window.gtag) gtag('event', gaEvt, { coupon_code: code, brand: state.brand });
              if (window.dataLayer) dataLayer.push({ event: gaEvt, coupon_code: code, brand: state.brand });
            } catch(_) {}
          }
          setTimeout(() => {
            btn.innerHTML = origHtml;
            btn.classList.remove('is-copied');
            if (nudgeEl) nudgeEl.classList.remove('is-visible');
          }, 3200);
        });
      });
      root.querySelectorAll('[data-aps-terms]').forEach(btn => {
        const body = document.getElementById('aps-terms-' + btn.dataset.apsTerms);
        if (!body) return;
        btn.addEventListener('click', () => {
          const open = body.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open);
          btn.textContent = (open ? 'Hide Details ▴' : 'View Details ▾');
        });
      });
    };
    'requestIdleCallback' in window ? requestIdleCallback(initFn) : setTimeout(initFn, 200);

    const dealGrid = document.getElementById('aps-deal-grid-' + UID);
    const dotsWrap = document.getElementById('aps-deal-dots-' + UID);
    if (dealGrid && dotsWrap) {
      const dots = [...dotsWrap.querySelectorAll('.aps-deal-dot')];
      function getClosestCardIdx() {
        const cards = [...dealGrid.querySelectorAll('.aps-deal-card')];
        let closest = 0, minDist = Infinity;
        const gridLeft = dealGrid.getBoundingClientRect().left;
        cards.forEach((c, i) => {
          const d = Math.abs(c.getBoundingClientRect().left - gridLeft);
          if (d < minDist) { minDist = d; closest = i; }
        });
        return { closest, cards };
      }
      function scrollToCardIdx(idx) {
        const cards = [...dealGrid.querySelectorAll('.aps-deal-card')];
        if (!cards[idx]) return;
        const relLeft = cards[idx].getBoundingClientRect().left - dealGrid.getBoundingClientRect().left + dealGrid.scrollLeft;
        dealGrid.scrollTo({ left: relLeft, behavior: 'smooth' });
      }
      dealGrid.addEventListener('scroll', () => {
        const { closest } = getClosestCardIdx();
        dots.forEach((d, i) => d.classList.toggle('is-active', i === closest));
      }, { passive: true });
      const prevBtn = dotsWrap.querySelector('.aps-deal-prev');
      const nextBtn = dotsWrap.querySelector('.aps-deal-next');
      if (prevBtn) prevBtn.addEventListener('click', () => {
        const { closest, cards } = getClosestCardIdx();
        scrollToCardIdx((closest - 1 + cards.length) % cards.length);
      });
      if (nextBtn) nextBtn.addEventListener('click', () => {
        const { closest, cards } = getClosestCardIdx();
        scrollToCardIdx((closest + 1) % cards.length);
      });
      // Autoplay — pauses on hover/touch, slows when in viewport
      const dcEl = document.getElementById('aps-deals-' + UID);
      if (dcEl && dcEl.dataset.apsAutoplay === 'true') {
        const apMs   = parseInt(dcEl.dataset.apsAutoplayInterval || '4') * 1000;
        const slowMs = apMs * 2;
        let apTimer    = null;
        let isViewing  = false;
        let isHovered  = false;
        function step() {
          const { closest, cards } = getClosestCardIdx();
          scrollToCardIdx((closest + 1) % cards.length);
        }
        function startTimer(ms) { clearInterval(apTimer); apTimer = setInterval(step, ms); }
        function stopTimer()    { clearInterval(apTimer); apTimer = null; }
        function updateAutoplay() {
          if (!isViewing || isHovered) { stopTimer(); return; }
          startTimer(slowMs);
        }
        new IntersectionObserver(([entry]) => {
          isViewing = entry.isIntersecting;
          updateAutoplay();
        }, { threshold: 0.3 }).observe(dcEl);
        dealGrid.addEventListener('mouseenter', () => { isHovered = true;  updateAutoplay(); });
        dealGrid.addEventListener('mouseleave', () => { isHovered = false; updateAutoplay(); });
        dealGrid.addEventListener('touchstart', () => { isHovered = true;  updateAutoplay(); }, { passive: true });
        dealGrid.addEventListener('touchend',   () => { setTimeout(() => { isHovered = false; updateAutoplay(); }, 3000); }, { passive: true });
      }
    }
  }
  initDealCenter();

  /* ── Boot ── */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  } /* end initAPS */

  var _booted = false;
  function boot() {
    if (_booted) return;
    _booted = true;
    var roots = document.querySelectorAll('[data-aps]');
    for (var i = 0; i < roots.length; i++) { initAPS(roots[i]); }
  }
  /* Init on DOMContentLoaded. NOTE: do NOT wrap in requestIdleCallback — the Pro Selector
     is above-the-fold and its init affects grid rendering; deferring it to idle delayed
     LCP from 4.6s to 11-14s on mobile (tested 2026-05-28). TBT dropped but LCP/score got
     much worse. DOMContentLoaded is the correct trigger here. */
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  /* Shopify theme-editor: re-init immediately (not idle) when section is reloaded so the editor preview stays responsive */
  document.addEventListener('shopify:section:load', function (e) {
    var r = (e.target && e.target.querySelector) ? e.target.querySelector('[data-aps]') : null;
    if (r) initAPS(r);
  });
})();
